var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "18px",
    width: "18px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 236.108 236.108",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,69.21c-4.142,0-7.5,3.358-7.5,7.5v58.54c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V76.71 C15,72.568,11.642,69.21,7.5,69.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.428,25.459h-31.204c-4.142,0-7.5,3.358-7.5,7.5v6.775L27.289,69.517c-3.184,0.944-5.368,3.87-5.368,7.19v58.512 c-0.002,0.375,0.034,0.753,0.09,1.132c0.01,0.07,0.02,0.14,0.032,0.209c0.056,0.31,0.124,0.62,0.221,0.928l21.261,67.9 c1.004,3.207,3.963,5.261,7.155,5.261c0.741,0,1.495-0.111,2.24-0.344l30.961-9.681c1.899-0.594,3.484-1.918,4.406-3.68 c0.923-1.762,1.107-3.819,0.513-5.718l-10.536-33.669l49.459,14.67v6.774c0,4.142,3.358,7.5,7.5,7.5h31.204 c4.142,0,7.5-3.358,7.5-7.5V32.959C173.928,28.817,170.57,25.459,166.428,25.459z M72.245,188.546l-16.646,5.205l-14.814-47.311 l20.154,5.977L72.245,188.546z M69.078,139.187c-0.021-0.006-0.043-0.013-0.064-0.019l-32.092-9.519V82.306l90.803-26.926v101.202 L69.078,139.187z M158.928,171.502h-16.204v-4.873V45.333v-4.873h16.204V171.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.962,147.969l-32.452-16.229c-3.706-1.851-8.21-0.352-10.063,3.354c-1.853,3.705-0.351,8.21,3.354,10.063 l32.452,16.229c1.077,0.539,2.221,0.793,3.349,0.793c2.751,0,5.4-1.519,6.714-4.147 C230.168,154.327,228.666,149.822,224.962,147.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.161,81.012c1.127,0,2.272-0.255,3.348-0.794l32.453-16.227c3.705-1.853,5.207-6.357,3.354-10.062 c-1.852-3.705-6.358-5.207-10.062-3.354l-32.453,16.227c-3.705,1.853-5.207,6.357-3.354,10.062 C183.761,79.493,186.41,81.012,189.161,81.012z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.608,98.48h-27.098c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h27.098c4.142,0,7.5-3.358,7.5-7.5 C236.108,101.837,232.75,98.48,228.608,98.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.8e0af2737a725b73040a110afdbc3f25.svg";
export { ForwardRef as ReactComponent };